// Theme: monokai
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'monokai',
  name: 'MONOKAI',
  tagline: 'MONOKAI',
  description: 'Classico do Sublime Text. Magenta vibrante sobre marrom-verde escuro.',
  category: 'neon-cyber',
  tier: 'rare',
  basePrice: 1200,
  swatches: ['#272822', '#F92672', '#3E3D32', '#F8F8F2'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '16px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-mono theme-monokai'
  },
  colorVars: {
    '--accent': '#F92672',
    '--accent-foreground': '#272822',
    '--background': '#272822',
    '--border': '#313027',
    '--card': '#3E3D32',
    '--card-border-active': 'rgba(249, 38, 114, 0.10)',
    '--card-completed': '#444236',
    '--card-foreground': '#F8F8F2',
    '--card-glow': 'rgba(249, 38, 114, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#272822',
    '--foreground': '#F8F8F2',
    '--hold-fill': '#F92672',
    '--input': '#313027',
    '--modal-bg': '#272822',
    '--modal-border': '#313027',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#313027',
    '--muted-foreground': '#C6C3B2',
    '--nav-active': '#F92672',
    '--nav-bg': '#272822',
    '--popover': '#3E3D32',
    '--popover-foreground': '#F8F8F2',
    '--primary': '#F92672',
    '--primary-foreground': '#272822',
    '--ring': '#F92672',
    '--secondary': '#313027',
    '--secondary-foreground': '#F8F8F2',
    '--streak': '#F92672',
    '--success': '#22c55e',
    '--success-foreground': '#272822',
    '--xp': '#F92672',
    '--xp-bg': '#3E3D32'
  },
  resolvedVars: {
    '--accent': '#F92672',
    '--accent-foreground': '#272822',
    '--accent-foreground-hsl': '70 8% 15%',
    '--accent-foreground-oklch': 'from #272822 l c h',
    '--accent-hsl': '338 95% 56%',
    '--accent-oklch': 'from #F92672 l c h',
    '--background': '#272822',
    '--background-hsl': '70 8% 15%',
    '--background-oklch': 'from #272822 l c h',
    '--border': '#313027',
    '--border-hsl': '54 11% 17%',
    '--border-oklch': 'from #313027 l c h',
    '--border-w': '1px',
    '--card': '#3E3D32',
    '--card-border-active': 'rgba(249, 38, 114, 0.10)',
    '--card-completed': '#444236',
    '--card-completed-hsl': '51 11% 24%',
    '--card-completed-oklch': 'from #444236 l c h',
    '--card-foreground': '#F8F8F2',
    '--card-foreground-hsl': '60 30% 96%',
    '--card-foreground-oklch': 'from #F8F8F2 l c h',
    '--card-glow': 'rgba(249, 38, 114, 0.03)',
    '--card-hsl': '55 11% 22%',
    '--card-oklch': 'from #3E3D32 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#272822',
    '--destructive-foreground-hsl': '70 8% 15%',
    '--destructive-foreground-oklch': 'from #272822 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F8F8F2',
    '--foreground-hsl': '60 30% 96%',
    '--foreground-oklch': 'from #F8F8F2 l c h',
    '--hold-fill': '#F92672',
    '--hold-fill-hsl': '338 95% 56%',
    '--hold-fill-oklch': 'from #F92672 l c h',
    '--input': '#313027',
    '--input-hsl': '54 11% 17%',
    '--input-oklch': 'from #313027 l c h',
    '--modal-bg': '#272822',
    '--modal-bg-hsl': '70 8% 15%',
    '--modal-bg-oklch': 'from #272822 l c h',
    '--modal-border': '#313027',
    '--modal-border-hsl': '54 11% 17%',
    '--modal-border-oklch': 'from #313027 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#313027',
    '--muted-foreground': '#C6C3B2',
    '--muted-foreground-hsl': '51 15% 74%',
    '--muted-foreground-oklch': 'from #C6C3B2 l c h',
    '--muted-hsl': '54 11% 17%',
    '--muted-oklch': 'from #313027 l c h',
    '--nav-active': '#F92672',
    '--nav-active-hsl': '338 95% 56%',
    '--nav-active-oklch': 'from #F92672 l c h',
    '--nav-bg': '#272822',
    '--nav-bg-hsl': '70 8% 15%',
    '--nav-bg-oklch': 'from #272822 l c h',
    '--popover': '#3E3D32',
    '--popover-foreground': '#F8F8F2',
    '--popover-foreground-hsl': '60 30% 96%',
    '--popover-foreground-oklch': 'from #F8F8F2 l c h',
    '--popover-hsl': '55 11% 22%',
    '--popover-oklch': 'from #3E3D32 l c h',
    '--primary': '#F92672',
    '--primary-foreground': '#272822',
    '--primary-foreground-hsl': '70 8% 15%',
    '--primary-foreground-oklch': 'from #272822 l c h',
    '--primary-hsl': '338 95% 56%',
    '--primary-oklch': 'from #F92672 l c h',
    '--radius': '16px',
    '--ring': '#F92672',
    '--ring-hsl': '338 95% 56%',
    '--ring-oklch': 'from #F92672 l c h',
    '--secondary': '#313027',
    '--secondary-foreground': '#F8F8F2',
    '--secondary-foreground-hsl': '60 30% 96%',
    '--secondary-foreground-oklch': 'from #F8F8F2 l c h',
    '--secondary-hsl': '54 11% 17%',
    '--secondary-oklch': 'from #313027 l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#F92672',
    '--streak-hsl': '338 95% 56%',
    '--streak-oklch': 'from #F92672 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#272822',
    '--success-foreground-hsl': '70 8% 15%',
    '--success-foreground-oklch': 'from #272822 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(338 95% 56% / 0.15)',
    '--xp': '#F92672',
    '--xp-bg': '#3E3D32',
    '--xp-bg-hsl': '55 11% 22%',
    '--xp-bg-oklch': 'from #3E3D32 l c h',
    '--xp-hsl': '338 95% 56%',
    '--xp-oklch': 'from #F92672 l c h'
  }
}
